export default __webpack_public_path__ + "static/broadcastImg3-9942fd4f51f707bc0d0530cea85d399d.webp";